import { INDIA_CITY_OPTIONS } from "./indiaCities";

const CITY_OPTIONS_BY_COUNTRY = {
  IN: INDIA_CITY_OPTIONS,
  US: [
    "New York",
    "Los Angeles",
    "Chicago",
    "Houston",
    "Phoenix",
    "Philadelphia",
    "San Antonio",
    "San Diego",
    "Dallas",
    "San Jose",
    "Austin",
    "Jacksonville",
    "Fort Worth",
    "Columbus",
    "Charlotte",
    "San Francisco",
    "Indianapolis",
    "Seattle",
    "Denver",
    "Washington DC",
    "Boston",
    "El Paso",
    "Nashville",
    "Detroit",
    "Portland",
    "Las Vegas",
    "Memphis",
    "Louisville",
    "Baltimore",
    "Milwaukee",
    "Albuquerque",
    "Tucson",
    "Fresno",
    "Sacramento",
    "Mesa",
    "Atlanta",
    "Kansas City",
    "Colorado Springs",
    "Miami",
    "Raleigh",
    "Omaha",
    "Long Beach",
    "Virginia Beach",
    "Oakland",
    "Minneapolis",
    "Tampa",
    "Orlando",
    "Pittsburgh",
    "Cincinnati",
    "Cleveland",
    "Salt Lake City",
  ],
  CA: ["Toronto", "Vancouver", "Montreal", "Calgary", "Ottawa", "Edmonton", "Winnipeg", "Quebec City", "Hamilton", "Mississauga", "Brampton", "Surrey", "Halifax", "Victoria", "Saskatoon", "Regina"],
  GB: ["London", "Birmingham", "Manchester", "Leeds", "Glasgow", "Liverpool", "Newcastle upon Tyne", "Sheffield", "Bristol", "Nottingham", "Leicester", "Edinburgh", "Cardiff", "Belfast", "Coventry", "Bradford"],
  AU: ["Sydney", "Melbourne", "Brisbane", "Perth", "Adelaide", "Gold Coast", "Canberra", "Newcastle", "Wollongong", "Hobart", "Geelong", "Townsville", "Cairns", "Darwin"],
  NZ: ["Auckland", "Wellington", "Christchurch", "Hamilton", "Tauranga", "Dunedin", "Lower Hutt", "Palmerston North", "Napier", "Rotorua", "Nelson"],
  AE: ["Dubai", "Abu Dhabi", "Sharjah", "Ajman", "Ras Al Khaimah", "Fujairah", "Umm Al Quwain", "Al Ain"],
  SA: ["Riyadh", "Jeddah", "Mecca", "Medina", "Dammam", "Khobar", "Dhahran", "Taif", "Tabuk", "Al Jubail"],
  QA: ["Doha", "Al Rayyan", "Al Wakrah", "Umm Salal", "Al Khor", "Dukhan", "Lusail"],
  KW: ["Kuwait City", "Hawalli", "Salmiya", "Farwaniya", "Jahra", "Mangaf", "Fahaheel"],
  OM: ["Muscat", "Salalah", "Sohar", "Nizwa", "Sur", "Seeb", "Barka"],
  BH: ["Manama", "Riffa", "Muharraq", "Hamad Town", "Isa Town", "Sitra"],
  SG: ["Singapore", "Jurong East", "Tampines", "Woodlands", "Yishun", "Bedok", "Hougang"],
  MY: ["Kuala Lumpur", "George Town", "Johor Bahru", "Ipoh", "Kuching", "Kota Kinabalu", "Shah Alam", "Malacca", "Petaling Jaya"],
  ID: ["Jakarta", "Surabaya", "Bandung", "Medan", "Semarang", "Makassar", "Denpasar", "Yogyakarta", "Bekasi", "Tangerang"],
  TH: ["Bangkok", "Chiang Mai", "Phuket", "Pattaya", "Nonthaburi", "Hat Yai", "Khon Kaen", "Udon Thani"],
  VN: ["Ho Chi Minh City", "Hanoi", "Da Nang", "Hai Phong", "Can Tho", "Nha Trang", "Hue"],
  PH: ["Manila", "Quezon City", "Makati", "Cebu City", "Davao City", "Taguig", "Pasig", "Baguio"],
  BD: ["Dhaka", "Chittagong", "Sylhet", "Khulna", "Rajshahi", "Barisal", "Rangpur"],
  PK: ["Karachi", "Lahore", "Islamabad", "Rawalpindi", "Faisalabad", "Multan", "Peshawar", "Quetta", "Sialkot"],
  LK: ["Colombo", "Kandy", "Galle", "Jaffna", "Negombo", "Batticaloa", "Anuradhapura"],
  NP: ["Kathmandu", "Pokhara", "Lalitpur", "Bhaktapur", "Biratnagar", "Birgunj", "Dharan"],
  CN: ["Beijing", "Shanghai", "Guangzhou", "Shenzhen", "Chengdu", "Hangzhou", "Wuhan", "Xi'an", "Nanjing", "Tianjin"],
  JP: ["Tokyo", "Osaka", "Kyoto", "Yokohama", "Nagoya", "Sapporo", "Fukuoka", "Kobe", "Hiroshima"],
  KR: ["Seoul", "Busan", "Incheon", "Daegu", "Daejeon", "Gwangju", "Suwon", "Ulsan"],
  HK: ["Hong Kong", "Kowloon", "Central", "Tsim Sha Tsui", "Sha Tin", "Tsuen Wan"],
  DE: ["Berlin", "Munich", "Hamburg", "Frankfurt", "Cologne", "Dusseldorf", "Stuttgart", "Dortmund", "Leipzig"],
  FR: ["Paris", "Marseille", "Lyon", "Toulouse", "Nice", "Nantes", "Strasbourg", "Bordeaux", "Lille"],
  IT: ["Rome", "Milan", "Naples", "Turin", "Florence", "Bologna", "Venice", "Genoa", "Palermo"],
  ES: ["Madrid", "Barcelona", "Valencia", "Seville", "Zaragoza", "Malaga", "Bilbao", "Granada"],
  NL: ["Amsterdam", "Rotterdam", "The Hague", "Utrecht", "Eindhoven", "Groningen", "Tilburg"],
  CH: ["Zurich", "Geneva", "Basel", "Bern", "Lausanne", "Lucerne", "Lugano"],
  SE: ["Stockholm", "Gothenburg", "Malmo", "Uppsala", "Vasteras", "Orebro", "Linkoping"],
  NO: ["Oslo", "Bergen", "Trondheim", "Stavanger", "Drammen", "Tromso"],
  DK: ["Copenhagen", "Aarhus", "Odense", "Aalborg", "Esbjerg", "Randers"],
  IE: ["Dublin", "Cork", "Galway", "Limerick", "Waterford", "Drogheda"],
  ZA: ["Johannesburg", "Cape Town", "Durban", "Pretoria", "Port Elizabeth", "Bloemfontein"],
  KE: ["Nairobi", "Mombasa", "Kisumu", "Nakuru", "Eldoret", "Malindi"],
  NG: ["Lagos", "Abuja", "Kano", "Ibadan", "Port Harcourt", "Benin City"],
  EG: ["Cairo", "Alexandria", "Giza", "Luxor", "Aswan", "Port Said"],
  TR: ["Istanbul", "Ankara", "Izmir", "Bursa", "Antalya", "Konya", "Adana"],
  RU: ["Moscow", "Saint Petersburg", "Novosibirsk", "Yekaterinburg", "Kazan", "Sochi"],
  BR: ["Sao Paulo", "Rio de Janeiro", "Brasilia", "Salvador", "Fortaleza", "Curitiba"],
  MX: ["Mexico City", "Guadalajara", "Monterrey", "Puebla", "Tijuana", "Cancun"],
  AR: ["Buenos Aires", "Cordoba", "Rosario", "Mendoza", "La Plata", "Mar del Plata"],
};

export function getCityOptionsForCountry(countryOption) {
  if (!countryOption?.iso) return INDIA_CITY_OPTIONS;
  return CITY_OPTIONS_BY_COUNTRY[countryOption.iso] || [
    countryOption.country,
    "Capital city",
    "Major city",
    "Other city",
  ];
}
